import { Component, OnInit, Injector } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase } from 'vnpost-shared';
import { ServiceProductService } from '../../services/service-product.service';
import { GroupServiceProductService } from '../../services/group-service-product.service';
import { CalculateUnitService } from '../../services/calculate-unit.service';
@Component({
  selector: 'app-edit-service-product',
  templateUrl: './edit-service-product.component.html',
  styleUrls: ['./edit-service-product.component.css']
})
export class EditServiceProductComponent extends SecondPageEditBase implements OnInit {
  listStatus: { label: string; value: number }[] = [
    { label: 'Đang áp dụng', value: 1 },
    { label: 'Ngừng áp dụng', value: 0 },
  ];
  isDisable: any;
  listBusinessSector: { label: string; value: number }[]=[
    { label: 'Dịch vụ bưu chính', value: 1 },
    { label: 'Tài chính bưu chính', value: 2 },
    { label: 'Phân phối truyền thông', value: 3 },
  ]
  listServiceProductService: { label: string; value: string }[]=[];
  listMeasurementUnit: { label: string; value: number }[]=[];

  constructor(
    protected _serviceProductService: ServiceProductService,
    protected _groupServiceProductService: GroupServiceProductService,
    protected _calculateUnit: CalculateUnitService,
    protected _injector: Injector
  ) {
    super(_serviceProductService, _injector);
    this.formGroup = new UntypedFormGroup({
      businessSectorCode: new UntypedFormControl('', [Validators.required]),
      serviceProductGroupCode: new UntypedFormControl('', [Validators.required]),
      serviceProductCode: new UntypedFormControl('', [Validators.required]),
      serviceProductName: new UntypedFormControl('', [Validators.required]),
      measurementUnitId: new UntypedFormControl('', [Validators.required]), // đơn vị tính
      status: new UntypedFormControl('', [Validators.required]),
      hasPrice: new UntypedFormControl('', [Validators.required]),
      unitPrice: new UntypedFormControl('', [Validators.required, Validators.pattern(/^\d*$/)]),
      notes: new UntypedFormControl(''),
      vat: new UntypedFormControl('', [Validators.required, Validators.pattern(/^100(\.00?)?$|^\d{1,2}(\.\d{1,2})?$/)]),
      description: new UntypedFormControl('', [Validators.required])
    });
  }

  ngOnInit() {}

  onChangeBusinessSector() {
    const model = {
      businessSectorCode: this.itemDetail.businessSectorCode
    }
    this._groupServiceProductService.getListServiceProduct(model).then(res => {
      this.listServiceProductService = res?.data.map(x => ({label: `${x.serviceProductGroupName} (${x.serviceProductGroupCode})`, value: x.serviceProductGroupCode}));
    },err => {
      this.listServiceProductService = [];
    })
  }

  getMeasurementUnit() {
    const model = {
    }
    this._calculateUnit.getListCalculateUnit(model).then(res => {
      this.listMeasurementUnit = res?.data.map(x => ({label: `${x.unitName} (${x.symbol})`, value: x.id}));
    },err => {
      this.listMeasurementUnit = [];
    })
  }

  onShowPopup(model: any) {
    if (this.listMeasurementUnit.length == 0) {
      this.getMeasurementUnit();
    }
    this.isDisable = model.isDisable;
    this.validationSummary.resetErrorMessages();
    this.resetForm();

    if (model.id > 0) {
      this._serviceProductService.getServiceProductDetail(model.id).then(
        (rs) => {
          this.itemDetail = rs.data;
          if (this.itemDetail.unitPrice) this.itemDetail.hasPrice = true;
          else this.itemDetail.hasPrice = false;
          if (this.itemDetail.businessSectorCode) this.onChangeBusinessSector();
        },
        (error) => {
          this._notifierService.showWarning(
            this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
          );
        }
      );
    }
  }

  async save() {
    this.submitting = true;

    if (this.formGroup.invalid) {
      this.submitting = false;
      this.validationSummary.showValidationSummary();
      return;
    }

    this.onUpdate();
  }

  onUpdate() {
    if (!this.itemDetail.hasPrice) this.itemDetail.unitPrice = 0;
    this._serviceProductService.update(this.itemDetail.id, this.itemDetail).then(
      (response) => {
        this.closePopupMethod(true);
        this._notifierService.showUpdateDataSuccess();
        this.onAfterSave();
        this.submitting = false;
      },
      (error) => {
        this._notifierService.showUpdateDataFailed();
        this.submitting = false;
      }
    );
  }
}
